import {
  LineageBrowserDataCatalogProvider,
  VizPortalDataCatalogProviderProps,
} from '@tableau/data-catalog-shared';
import * as React from 'react';
import { FlowLineageSubplaceRouter, FlowLineageSubplaceRouterProps } from './FlowLineageSubplace';

export type EmbeddableFlowSubplaceProps = VizPortalDataCatalogProviderProps & FlowLineageSubplaceRouterProps;

export function EmbeddableFlowSubplaceWithoutRouter(props: EmbeddableFlowSubplaceProps): JSX.Element {
  return (
    <LineageBrowserDataCatalogProvider {...props}>
      <FlowLineageSubplaceRouter flowVizportalUrlId={props.flowVizportalUrlId} shouldShowFlowParametersWarning={props.shouldShowFlowParametersWarning} />
    </LineageBrowserDataCatalogProvider>
  );
}
